import React, { useState } from 'react';
import { FormField } from '../../components/Formulaire/FormField';

function Contact() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Name:', name);
        console.log('Email:', email);
        console.log('Message:', message);
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-100 to-blue-50 p-6">
            <div className="w-full md:w-2/3 lg:w-1/2">
                <div className="bg-white shadow-xl rounded-2xl p-8">
                    <div className="text-center mb-6">
                        <h2 className="text-4xl font-bold text-gray-800">📩 Contactez-nous</h2>
                        <p className="text-gray-500 mt-2">Nous serons ravis de vous aider !</p>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <FormField label="Nom:">
                            <input
                                type="text"
                                id="formName"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                required
                                className="input input-bordered w-full px-4 py-2 rounded-lg focus:ring focus:ring-primary transition"
                            />
                        </FormField>
                        <FormField label="Email:">
                            <input
                                type="email"
                                id="formEmail"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="input input-bordered w-full px-4 py-2 rounded-lg focus:ring focus:ring-primary transition"
                            />
                        </FormField>
                        <FormField label="Message:">
                            <textarea
                                id="formMessage"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                required
                                rows="4"
                                className="textarea textarea-bordered w-full px-4 py-2 rounded-lg focus:ring focus:ring-primary transition"
                            />
                        </FormField>
                        <div className="flex justify-center mt-6">
                            <button 
                                type="submit" 
                                className="btn btn-neutral btn-wide rounded-full shadow-md transition hover:scale-105"
                            >
                                ✨ Envoyer
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Contact;
